import axios from 'axios';
import moment from 'moment';

import type { VirtualTourJsonType } from '@bb/domain/dist/types';

interface FinalTours extends VirtualTourJsonType {
  key: string;
}
interface GetDataProps {
  dashboardId: string;
  retsId: string;
  coopId: string;
  listingId: string;
}

interface AxiosGetVirtualTour {
  virtualTours: FinalTours[];
  tourListings: { virtualTour: string; listing: string }[];
}

const getVirtualTourForDash = async ({
  dashboardId,
  retsId,
  coopId,
  listingId,
}: GetDataProps): Promise<FinalTours[]> => {
  const isExternal = dashboardId || retsId;
  const {
    data: { virtualTours = [], tourListings = [] },
  } = await axios.get<AxiosGetVirtualTour>(
    isExternal ? '/external/virtual_tour' : '/virtual_tour',
    {
      params: { retsId, dashboardId, coopId },
    },
  );

  const listingMap: Record<string, string[]> = {};

  tourListings.forEach((tl: any) => {
    if (listingMap[tl.virtualTour]) {
      listingMap[tl.virtualTour].push(tl.listing);
    } else {
      listingMap[tl.virtualTour] = [tl.listing];
    }
  });

  // filters out vtours with this listing already
  const filteredTours = virtualTours.filter((virtualTour: any) => {
    if (!listingMap[virtualTour.id]) return true;
    if (listingMap[virtualTour.id]?.includes(listingId)) {
      return false;
    }
    return true;
  });

  const finalTours = filteredTours
    .sort(
      (a: any, b: any) =>
        new Date(a.startTime).getTime() - new Date(b.startTime).getTime(),
    )
    .map((virtualTour: any) => ({
      ...virtualTour,
      key: virtualTour._id,
      startTime: moment(virtualTour.startTime).format('MMM Do, h:mm a'),
      listings: listingMap[virtualTour.id]
        ? listingMap[virtualTour.id].length
        : 0,
    }));

  return finalTours;
};
export default getVirtualTourForDash;
